export default __webpack_public_path__ + "static/media/html.75bdf0b0.svg";